// extracted by mini-css-extract-plugin
export default {"trash":"process-time_trash__X6Vru","cell":"process-time_cell__gZa6E"};